module.exports = __webpack_public_path__ + "static/img/83084G_1_2_R_20220618_fit.33734ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/83084G_1_2_R_20220618_fit.png
// module id = 3TBj
// module chunks = 0